import { MnoConfig } from '../types';

export const devConfig: MnoConfig = {
  id: 'berd_3',
  name: 'Life Development',
  colors: {
    primary: '#0A69AE',  // Life blue
    secondary: '#FDCD01', // MTN Yellow
  },
  countryCode: '234',
  phoneNumberMask: '000 000 0000',
  appUrl: 'https://life-frontend.1pin.com',
  locations: [
    "San Francisco",
    "Los Angeles",
    "Chicago",
    "Boston",
    "Seattle",
    "Austin",
    "Miami",
    "Denver",
    "New York",
  ],
};

